import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { formSchema, FormValues } from '../schemas';
import { FormMode } from '@/types/form';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData: FormValues;
  handleSubmit: (data: FormValues) => Promise<void>;
}

function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  handleSubmit
}: FormDialogProps) {
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={initialData}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<BasicInfo mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
